import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { useCaptureError } from '@/lib/posthog/hooks/useCaptureError';

import { ErrorBoundaryFallback } from './errorBoundaryFallback/ErrorBoundaryFallback';

/**
 * React Router catches render errors itself, so without this they skip the
 * PostHogErrorBoundary in `main.tsx`: users saw the router's "Hey developer"
 * page and PostHog recorded nothing.
 */
export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const captureError = useCaptureError();

  useEffect(() => {
    captureError(error, { errorType: 'route-render-error' });
  }, [captureError, error]);

  return <ErrorBoundaryFallback />;
};
